import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createSysDictionaryDetail, deleteSysDictionaryDetail as _deleteSysDictionaryDetail, updateSysDictionaryDetail, findSysDictionaryDetail, getSysDictionaryDetailList } from '@/api/sysDictionaryDetail'; //  此处请自行替换地址
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
export default {
  name: 'SysDictionaryDetail',
  filters: {
    formatDate: function formatDate(time) {
      if (time !== null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool !== null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSysDictionaryDetailList,
      dialogFormVisible: false,
      type: '',
      formData: {
        label: null,
        value: null,
        status: true,
        sort: null
      },
      rules: {
        label: [{
          required: true,
          message: '请输入展示值',
          trigger: 'blur'
        }],
        value: [{
          required: true,
          message: '请输入字典值',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '排序标记',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.searchInfo.sysDictionaryID = Number(this.$route.params.id);
    this.getTableData();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      if (this.searchInfo.status === '') {
        this.searchInfo.status = null;
      }
      this.getTableData();
    },
    updateSysDictionaryDetail: function updateSysDictionaryDetail(row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return findSysDictionaryDetail({
                ID: row.ID
              });
            case 1:
              res = _context.sent;
              _this.type = 'update';
              if (res.code === 0) {
                _this.formData = res.data.resysDictionaryDetail;
                _this.dialogFormVisible = true;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        label: null,
        value: null,
        status: true,
        sort: null,
        sysDictionaryID: ''
      };
    },
    deleteSysDictionaryDetail: function deleteSysDictionaryDetail(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              row.visible = false;
              _context2.next = 1;
              return _deleteSysDictionaryDetail({
                ID: row.ID
              });
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  type: 'success',
                  message: '删除成功'
                });
                if (_this2.tableData.length === 1 && _this2.page > 1) {
                  _this2.page--;
                }
                _this2.getTableData();
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this3.formData.sysDictionaryID = Number(_this3.$route.params.id);
              _this3.$refs['elForm'].validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                  var res, _t;
                  return regeneratorRuntime.wrap(function (_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (valid) {
                          _context3.next = 1;
                          break;
                        }
                        return _context3.abrupt("return");
                      case 1:
                        _t = _this3.type;
                        _context3.next = _t === 'create' ? 2 : _t === 'update' ? 4 : 6;
                        break;
                      case 2:
                        _context3.next = 3;
                        return createSysDictionaryDetail(_this3.formData);
                      case 3:
                        res = _context3.sent;
                        return _context3.abrupt("continue", 8);
                      case 4:
                        _context3.next = 5;
                        return updateSysDictionaryDetail(_this3.formData);
                      case 5:
                        res = _context3.sent;
                        return _context3.abrupt("continue", 8);
                      case 6:
                        _context3.next = 7;
                        return createSysDictionaryDetail(_this3.formData);
                      case 7:
                        res = _context3.sent;
                        return _context3.abrupt("continue", 8);
                      case 8:
                        if (res.code === 0) {
                          _this3.$message({
                            type: 'success',
                            message: '创建/更改成功'
                          });
                          _this3.closeDialog();
                          _this3.getTableData();
                        }
                      case 9:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openDialog: function openDialog() {
      this.type = 'create';
      this.dialogFormVisible = true;
    }
  }
};